/* Personal information form
 ========================================================================== */
import setAccountNavigation from './navigation';
import { initDropdowns } from '../dropdowns/lib';
import addDropdowns from '../dropdowns';
export default function infosForm() {
    const forms = document.querySelectorAll('body .infosForm');
    const container = document.querySelector('#mes-infos');
    let value;
    let message;
    forms.forEach((form) => {
        // For browsers not supporting submitter property in the submit event (Safari < 15)
        const buttons = form.querySelectorAll('button[type="submit"]');
        buttons.forEach((button) => {
            button.addEventListener('click', () => {
                value = button.value;
                message = button.dataset.message;
            });
            button.addEventListener('keydown', (event) => {
                if (event.key === 'Enter') {
                    value = button.value;
                    message = button.dataset.message;
                }
            });
        });
        form.addEventListener('submit', (event) => {
            event.preventDefault();
            event.stopPropagation();
            const action = event.submitter ? event.submitter.name : value;
            if (action === 'update') {
                fetch(form.action, {
                    method: 'POST',
                    body: new FormData(form),
                })
                    .then(response => response.text())
                    .then((body) => {
                    container.outerHTML = body;
                    setAccountNavigation();
                    infosForm();
                    initDropdowns();
                    addDropdowns();
                });
            }
            else if (action === 'delete') {
                if (window.confirm(event.submitter ? event.submitter.dataset.message : message) === true) {
                    const originalFormData = new FormData(form);
                    const deleteFormData = new FormData();
                    deleteFormData.append('delete_token', originalFormData.get('delete_token'));
                    fetch(form.dataset.deleteAction, {
                        method: 'POST',
                        redirect: 'follow',
                        body: deleteFormData,
                    })
                        .then(response => {
                        if (response.redirected) {
                            window.location.href = response.url;
                        }
                        return response.text();
                    })
                        .then((body) => {
                        container.outerHTML = body;
                        setAccountNavigation();
                        infosForm();
                        initDropdowns();
                        addDropdowns();
                    });
                }
            }
        });
    });
}
